import React, { FunctionComponent, ReactElement } from 'react'
import FloatingText from '@sport1/react-elements/FloatingText'
import Grid from '@sport1/react-elements/Grid'
import Image from '@sport1/react-elements/Image'
import AbsoluteLayout from '../../Layouts/Absolute'
import Alert from '../../BaseComponents/Alert'
import { getImageSource, useImageSource } from '../../utils/ImageHelper'
import SmallButton from '../../BaseComponents/Button/Standard/Small'
import { getTextContents, TextObject } from './TextContentHelper'

export type InlineSocialProps = {
    textObjects: TextObject[]
    imageUrl: string
    /** info about imageUrl for seo */
    alt?: string
    onPrimaryButtonPress: () => void
    primaryButtonText: string
    onSecondaryButtonPress: () => void
    secondaryButtonText: string
    aspectRatio: number
}

const InlineSocialPrivacy: FunctionComponent<InlineSocialProps> = ({
    textObjects,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryButtonPress,
    onSecondaryButtonPress,
    imageUrl,
    alt,
    aspectRatio,
}): ReactElement => {
    const [imageData, onError] = useImageSource({
        width: '100%',
        size: 'L',
        aspectRatio: 'ORIGINAL',
        imageUrl,
    })

    return (
        <AbsoluteLayout
            backgroundColor="pearl"
            component={
                <>
                    <Grid
                        position="absolute"
                        backgroundColor="GRAY25"
                        height="100%"
                        width="100%"
                        opacity={0.35}
                        zIndex={1}
                    />
                    <Image
                        src={getImageSource(imageData)}
                        alt={alt}
                        width="100%"
                        aspectRatio={aspectRatio}
                        onError={onError}
                        resizeMode="contain"
                    />
                </>
            }
            absoluteComponentStyle={{ height: '100%', zIndex: 1 }}
        >
            <Grid center>
                <Grid noExpand width={300}>
                    <Alert
                        backgroundColor="pearl"
                        text={
                            <FloatingText
                                textAlign="center"
                                textObjects={getTextContents(textObjects)}
                            />
                        }
                        primaryButton={
                            <SmallButton
                                backgroundColor="onyx"
                                expand
                                onPress={onPrimaryButtonPress}
                            >
                                {primaryButtonText}
                            </SmallButton>
                        }
                        secondaryButton={
                            <SmallButton
                                backgroundColor="moon-2"
                                expand
                                marginTop="8px"
                                onPress={onSecondaryButtonPress}
                            >
                                {secondaryButtonText}
                            </SmallButton>
                        }
                    />
                </Grid>
            </Grid>
        </AbsoluteLayout>
    )
}

export default InlineSocialPrivacy
